export enum ConnectionStatus {
  None = 0,
  Connecting = 1,
  Connected = 2,
  Disconnected = 3,
  Reconnecting = 4,
  Failed = 5,
}
